// eslint-disable-next-line operator-linebreak
export const PROJECT_DESCRIPTION =
  'A project will hold schema information for a database for a specific application.'
  + ' This allows you to use your diagrams to explore your production and non-production'
  + ' instances, and explore snapshots of your database from different points in time.';
